export default "__VITE_PUBLIC_ASSET__60abfb9b__"